/*

  # Modal toggle

  Co-controller to create a toggle button.

  This can also be used to extend data-class-active
  and data-class-inactive outside of a modal element,
  even if no toggle button is defined. The
  modalToggle.stateSubject elements can be placed
  anywhere in the document, including outside of
  the modalToggle controlled element, and provide
  their own data-class-active and data-class-inactive
  class state attributes.

  The modalToggle.toggleButton can also be placed
  outside of the controlled element and is also
  connected by the data-modal-id attribute.

  This example shows and hides icons on a toggle
  button:

  <button data-hook="modalToggle.toggleButton"
    data-modal-id="overflow-menu">
    <svg class="menu--open-icon d-block"
      data-hook="modalToggle.stateSubject"
      data-modal-id="overflow-menu"
      data-class-active="d-none"
      data-class-inactive="d-block">
      {{ icons.menu | safe }}
    </svg>
    <svg class="menu--close-icon d-none"
      data-hook="modalToggle.stateSubject"
      data-modal-id="overflow-menu"
      data-class-active="d-block"
      data-class-inactive="d-none">
      {{ icons.close | safe }}
    </svg>
  </button>
  <div data-hook="modal modalToggle"
    data-modal-id="overflow-menu">
  </div>

*/

import {
  assignController, controllersAvailable, getControllers,
  selectAll, setClassState, unsetClassState,
} from '../api/element-manipulation'

assignController('modalToggle', (element) => {
  const stateSubjects = selectAll(document, `[data-modal-id="${element.dataset.modalId}"][data-hook~="modalToggle.stateSubject"]`)
  const toggleButtons = selectAll(document, `[data-modal-id="${element.dataset.modalId}"][data-hook~="modalToggle.toggleButton"]`)
  // console.log('##### modal toggleButtons', toggleButtons)

  controllersAvailable(() => {
    const { modal } = getControllers(element)
    const toggleModal = (event) => {
      if (element.dataset.modalOpen === '1') {
        modal.close(event)
      } else {
        modal.open(event)
      }
    }
    toggleButtons.forEach((toggleButton) => {
      toggleButton.addEventListener('click', toggleModal)
    })
    modal.closed.push(() => {
      stateSubjects.forEach((stateSubject) => {
        unsetClassState(stateSubject, stateSubject.dataset.classActive)
        setClassState(stateSubject, stateSubject.dataset.classInactive)
      })
    })
    modal.opened.push(() => {
      stateSubjects.forEach((stateSubject) => {
        unsetClassState(stateSubject, stateSubject.dataset.classInactive)
        setClassState(stateSubject, stateSubject.dataset.classActive)
      })
    })
  })
})
